import CardAccountMailOutline from 'vue-material-design-icons/CardAccountMailOutline.vue'
import Help from 'vue-material-design-icons/Help.vue'
import CheckCircleOutline from 'vue-material-design-icons/CheckCircleOutline.vue'
import TextBoxEditOutline from 'vue-material-design-icons/TextBoxEditOutline.vue'
import BookOpenVariantOutline from 'vue-material-design-icons/BookOpenVariantOutline.vue'
import Home from 'vue-material-design-icons/Home.vue'
import AccountEditOutline from 'vue-material-design-icons/AccountEditOutline.vue'
import AccountFileTextOutline from 'vue-material-design-icons/AccountFileTextOutline.vue'
import TextBoxSearchOutline from 'vue-material-design-icons/TextBoxSearchOutline.vue'
import MagnifyExpand from 'vue-material-design-icons/MagnifyExpand.vue'

// Nav icons
import School from 'vue-material-design-icons/School.vue'
import AccountGroupOutline from 'vue-material-design-icons/AccountGroupOutline.vue'
import CardAccountDetails from 'vue-material-design-icons/CardAccountDetails.vue'
import FileDocumentMultipleOutline from 'vue-material-design-icons/FileDocumentMultipleOutline.vue'
import AccountBoxEditOutline from 'vue-material-design-icons/AccountBoxEditOutline.vue'
import FormatListChecks from 'vue-material-design-icons/FormatListChecks.vue'
import PencilBoxOutline from 'vue-material-design-icons/PencilBoxOutline.vue'

export const mdiIcons = {
  CardAccountMailOutline,
  Help,
  CheckCircleOutline,
  TextBoxEditOutline,
  BookOpenVariantOutline,
  Home,
  School,
  AccountGroupOutline,
  CardAccountDetails,
  FileDocumentMultipleOutline,
  AccountEditOutline,
  AccountFileTextOutline,
  TextBoxSearchOutline,
  MagnifyExpand,
  AccountBoxEditOutline,
  FormatListChecks,
  PencilBoxOutline
}

export default {
  install(app) {
    // Automatyczna rejestracja ikon z prefiksem Mdi
    Object.entries(mdiIcons).forEach(([name, component]) => {
      app.component(`Mdi${name}`, component)
    })
  }
}
